export const backendBaseURL = process.env.REACT_APP_BACKEND_BASE_URL;
export const zoomChartsLicense = process.env.REACT_APP_ZOOM_CHARTS_LICENSE;
export const zoomChartsLicenseKey =
  process.env.REACT_APP_ZOOM_CHARTS_LICENSE_KEY;
export const collaborateEmail = process.env.REACT_APP_COLLABORATE_EMAIL;
export const googleAnalyticsTrackingId =
  process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID;
